import { render, staticRenderFns } from "./gift_campaigns.vue?vue&type=template&id=15686006&scoped=true"
import script from "./gift_campaigns.vue?vue&type=script&lang=js"
export * from "./gift_campaigns.vue?vue&type=script&lang=js"
import style0 from "./gift_campaigns.vue?vue&type=style&index=0&id=15686006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15686006",
  null
  
)

export default component.exports